import React from 'react'
import { FastField, Field } from 'formik'
import FormikInput from '../FormikInput'
import FormikSelect, { Option } from '../FormikSelect'
import { buzzlRoles } from '../../utils/config'

type BuzzlUserFormProps = {
  isSubmitting: boolean
  customers: Option[]
  showCustomers: boolean
}

const BuzzlUserEditForm: React.FC<BuzzlUserFormProps> = (props) => {
  return (
    <div className="divide-y divide-gray-200 px-4 sm:px-6">
      <fieldset className="space-y-6 pt-6 pb-5" disabled={props.isSubmitting}>
        <Field
          name="role"
          component={FormikSelect}
          label="Role"
          options={[
            { label: 'Admin', value: buzzlRoles.admin },
            { label: 'Operator', value: buzzlRoles.operator },
          ]}
        />
        <FastField type="email" name="email" component={FormikInput} label="Email" placeholder="user@email.com" />
        {/* <FastField type="text" name="displayName" component={FormikInput} label="Display Name" placeholder="name" /> */}
        <FastField type="text" name="firstName" component={FormikInput} label="First Name" placeholder="First Name" />
        <FastField type="text" name="lastName" component={FormikInput} label="Last Name" placeholder="Last Name" />
      </fieldset>
      {props.customers.length > 0 && props.showCustomers && (
        <fieldset className="space-y-6 pt-6 pb-5" disabled={props.isSubmitting}>
          <div className="flex flex-col">
            <label className="mb-2 text-base font-semibold leading-6">Assign Customers</label>
            <label className="text-sm font-normal leading-5 text-gray-500">
              If you’d like to limit access to specific customers you can specify access below.{' '}
            </label>
          </div>

          <Field name="customers" component={FormikSelect} label="Assign Customers" isMulti options={props.customers} />
        </fieldset>
      )}
    </div>
  )
}

export default BuzzlUserEditForm
